import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const href = "https://wa.me/447939365873?text=" + encodeURIComponent(
    "Hello HOMELARA, I would like to ask about your cleaning services in London."
  );
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with HOMELARA on WhatsApp"
      className="fixed bottom-[88px] right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] p-4 text-white shadow-2xl transition-transform duration-300 hover:scale-105 sm:bottom-[92px] sm:right-6"
    >
      <MessageCircle size={24} />
      <span className="hidden md:inline font-mono text-[11px] uppercase tracking-[0.15em] pr-1">
        Chat with us
      </span>
    </a>
  );
}
